// extracted by mini-css-extract-plugin
export default {"tags":"registration-email-form-header_tags__18UAN","tag":"registration-email-form-header_tag__pKjjS"};